import { action, computed, observable } from "mobx";
import Manager, { IManager } from "../services/Manager";
import { SelectOption } from "../components/common/forms/Interfaces";

export const BELARUS_REGION = "belarus";
export const OTHERS_REGION = "others";

export type RegionType = typeof BELARUS_REGION | typeof OTHERS_REGION;

export const REGION_10100_10200_CODE = "10100_10200";
export const REGION_10300_10400_CODE = "10300_10400";
export const REGION_10500_CODE = "10500";
export const REGION_10600_CODE = "10600";
export const REGION_10700_10800_CODE = "10700_10800";

export const REGION_10100_10200 = "10100, 10200";
export const REGION_10300_10400 = "10300, 10400";
export const REGION_10500 = "10500";
export const REGION_10600 = "10600";
export const REGION_10700_10800 = "10700, 10800";

export const REGION_OPTIONS = [
  {
    label: REGION_10100_10200,
    value: REGION_10100_10200_CODE,
  },
  {
    label: REGION_10300_10400,
    value: REGION_10300_10400_CODE,
  },
  {
    label: REGION_10500,
    value: REGION_10500_CODE,
  },
  {
    label: REGION_10600,
    value: REGION_10600_CODE,
  },
  {
    label: REGION_10700_10800,
    value: REGION_10700_10800_CODE,
  },
] as SelectOption[];

export type OtherRegionType =
  | typeof REGION_10100_10200
  | typeof REGION_10300_10400
  | typeof REGION_10500
  | typeof REGION_10600
  | typeof REGION_10700_10800;

export type RegionCodeType = typeof BELARUS_REGION | OtherRegionType;

export default class ClientsFeeCalculator {
  @observable
  region?: RegionType;

  @observable
  regionCode?: RegionCodeType;

  @observable
  client?: string;

  sum?: number;

  @computed
  get result() {
    return this._result;
  }

  @observable
  _result?: string | number | null;

  private manager: IManager = Manager;

  @action
  calculate(sum: number): void {
    this.sum = sum;
    this.manager
      .calculateClientsFee(this.prepareParametersForCalculation())
      .then(async (response) => {
        if (!response.ok) return;
        const data = await response.json();
        this._result = data.result;
      })
      .catch(() => {
        this._result = "No Data";
      });
  }

  @action
  reset(): void {
    this._result = null;
  }

  private prepareParametersForCalculation(): Record<string, unknown> {
    return {
      client_id: this.client,
      region_code: this.regionCode,
      sum: this.sum,
    };
  }
}
